"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var IndoorLightSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,15 L9,17 L8,17 L8,15 L9,15 Z M11.8535534,14.1464466 C12.0335412,14.3301571 12.3668746,14.6634904 12.8535534,15.1464466 C13.0488155,15.3417088 13.0488155,15.6582912 12.8535534,15.8535534 C12.679987,16.0271197 12.3707581,16.0733795 12.1464466,15.8535534 C11.9653296,15.6736474 11.6319963,15.3403141 11.1464466,14.8535534 C10.9511845,14.6582912 10.9511845,14.3417088 11.1464466,14.1464466 C11.320013,13.9728803 11.6273459,13.9339294 11.8535534,14.1464466 Z M5.85355339,14.1464466 C6.04881554,14.3417088 6.04881554,14.6582912 5.85355339,14.8535534 L4.85355339,15.8535534 C4.65829124,16.0488155 4.34170876,16.0488155 4.14644661,15.8535534 C3.95118446,15.6582912 3.95118446,15.3417088 4.14644661,15.1464466 L5.14644661,14.1464466 C5.34170876,13.9511845 5.65829124,13.9511845 5.85355339,14.1464466 Z M11,2 L11,3 L9,3 L9.00061211,6.0224767 C11.8035698,6.27537886 14.2426763,8.7311659 13.9775233,12.0006121 L11.6273459,12.0007845 C11.0654638,13.1828621 9.86041945,14.0000497 8.46451067,14.0000497 C7.0686019,14.0000497 5.86355753,13.1828621 5.3016754,12.0007845 L3.0224767,12.0006121 C2.74041352,8.72221049 5.19695546,6.27481555 8.00039328,6.02238608 L8,3 L6,3 L6,2 L11,2 Z M10.464,12 C10.3787945,12 9.0456385,12.0003423 6.46453186,12.0010269 C6.92296326,12.6101868 7.65237803,13.0000497 8.46451067,13.0000497 C9.15208589,13.0000497 9.98494788,12.6810433 10.464,12 Z M8.5,7 C6.18351313,7 4.27584058,8.75034218 4.02739677,11.0006121 C9.48626192,11.0006121 12.4679974,11.0006121 12.9726032,11.0006121 C12.6981232,8.67746327 10.7440967,7 8.5,7 Z" })));
};
IndoorLightSmall.displayName = 'IndoorLightSmall';
exports.default = IndoorLightSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=IndoorLightSmall.js.map